// extracted by mini-css-extract-plugin
module.exports = {"component":"icon-component--1K8Vz"};